@let s = viewState();
@if (s.state === 'loading' || s.state === 'ready') {
    <div class="suggestions-container">
        <div class="suggestions-header">
            <hive-icon-component [icon]="faSparkles" size="small" />
            <p class="suggestions-prompt">Try asking:</p>
            @if (s.state === 'ready') {
                <hive-button
                    class="refresh-button"
                    emphasis="tertiary"
                    size="smallest"
                    [icon]="faRefresh"
                    hiveTooltip
                    hiveTooltipDescription="Suggest different questions"
                    (click)="onRefresh()"
                ></hive-button>
            }
        </div>

        @for (q of s.questions; track q; let i = $index) {
            <hive-button
                class="suggestion-pill"
                data-testid="suggestion-pill"
                emphasis="secondary"
                size="small"
                [label]="q"
                [style.animation-delay.ms]="i * 60"
                hiveTooltip
                [hiveTooltipDescription]="q"
                (click)="onPillClick(q)"
            ></hive-button>
        }

        @if (s.state === 'loading') {
            @for (_ of skeletonPlaceholders; track $index; let i = $index) {
                @if (i >= s.questions.length) {
                    <span
                        class="suggestion-skeleton"
                        data-testid="suggestion-skeleton"
                        [style.animation-delay.ms]="i * 80"
                    ></span>
                }
            }
        }
    </div>
}
